export enum DistributionPayoutStatus {
  SCHEDULED = "Scheduled",
  DISTRIBUTED = "Distributed",
}
